export default __webpack_public_path__ + "static/media/rewardslogo.b9a4dc54.png";